import XLSX from 'xlsx-js-style';

export const exportToExcel = (filteredDrivers, columnConfig) => {
    const wb = XLSX.utils.book_new();
    const dataToExport = filteredDrivers.map(driver => {
        const rowData = {};
        columnConfig.forEach(column => {
            const keys = column.key.split('.');
            let value = driver;
            for (const key of keys) {
                if (value && key in value) {
                    value = value[key];
                } else {
                    value = 'N/A';
                    break;
                }
            }
            if (column.key === 'name') {
                const lastName = driver.last_name || 'N/A';
                value = `${value} ${lastName}`;
            }
                if (column.key === 'date_registration') {
                if (typeof value === 'number') {
                    const date = new Date(value);
                    rowData[column.label] = date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
                } else {
                    rowData[column.label] = value;
                }
            } else {
                rowData[column.label] = value;
            }
        });
        return rowData;
    });

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    ws['!charset'] = 'UTF-8';
    XLSX.utils.book_append_sheet(wb, ws, 'conductores');

    const columnWidths = [];
    columnConfig.forEach((column, columnIndex) => {
        const minWidth = 20;
        let maxWidth = minWidth;

        dataToExport.forEach(rowData => {
            const cellValue = rowData[column.label] || '';
            const cellWidth = cellValue.toString().length + 7;
            if (cellWidth > maxWidth) {
                maxWidth = cellWidth;
            }
        });

        if (maxWidth < minWidth) {
            maxWidth = minWidth;
        }

        columnWidths[columnIndex] = { width: maxWidth };
    });

    ws['!cols'] = columnWidths;
    XLSX.writeFile(wb, 'conductores.xlsx');
};